import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../common/utils';
import { ProfileFacade } from './profile.facade';

@Injectable({
  providedIn: 'root',
})
export class ProfileGuard {
  constructor(private userItemFacade: ProfileFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { userId },
    } = route;
    return checkStoreState(this.userItemFacade, userId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.userItemFacade);
  }
}
